import { createFileRoute } from '@tanstack/react-router'

import { exportReportDocument } from '@/components/report-viewer/export'
import { ReportPage } from '@/components/reports/report-page'
import { SalesReport } from '@/components/reports/sales/sales-report'
import { validateSalesReportSearch } from '@/components/reports/sales/sales-report-search'
import { useAuth } from '@/hooks/use-auth'
import { m } from '@/lib/paraglide/messages'

export const Route = createFileRoute('/_app/_authed/_sidebar/reports/sales')({
    validateSearch: validateSalesReportSearch,
    component: SalesReportPage,
})

function SalesReportPage() {
    const search = Route.useSearch()
    const navigate = Route.useNavigate()
    const { hasPermission } = useAuth()
    return (
        <ReportPage title={m.sales_report_page_title()}>
            <SalesReport
                search={search}
                onSearchChange={(next) =>
                    void navigate({
                        search: (prev) => ({ ...prev, ...next }),
                        replace: true,
                    })
                }
                exportDocument={
                    hasPermission('reports.export')
                        ? exportReportDocument
                        : undefined
                }
            />
        </ReportPage>
    )
}
